<div dropdown class="dropdown">
  <a
    [attr.data-id]="btnDetails.dataId"
    dropdownToggle
    mat-button
    [title]="btnDetails.title"
    (click)="trackEvent(btnDetails.title)"
  >
    <top-nav-btn-inner
      [btnDetails]="btnDetails"
      [isBolded]="isBolded"
    ></top-nav-btn-inner>
  </a>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
    <li
      role="menuitem"
      *ngFor="let dropdownItem of btnDetails.dropdownItems"
      [attr.data-id]="dropdownItem.dataId"
    >
      <ng-container
        *ngIf="
          canShowDropdownItem(dropdownItem) && dropdownItem.title != 'Live Chat'
        "
      >
        <a
          *ngIf="dropdownItem.isRouterlink"
          [routerLink]="dropdownItem.href"
          [title]="dropdownItem.title"
          (click)="trackEvent(dropdownItem.title)"
        >
          {{ dropdownItem.title }}
        </a>
        <a
          *ngIf="!dropdownItem.isRouterlink"
          [href]="dropdownItem.href"
          [target]="dropdownItem.openInNewTab ? '_blank' : ''"
          [title]="dropdownItem.title"
          (click)="trackEvent(dropdownItem.title)"
        >
          {{ dropdownItem.title }}
        </a>
      </ng-container>
      <ng-container *ngIf="dropdownItem.title == 'Live Chat'">
        <live-chat
          data-cy="NavLiveChat"
          [rgpTenantId]="rgpTenantId"
          class="live-chat"
        ></live-chat>
      </ng-container>
    </li>
  </ul>
</div>
